/**
 * 业务与银行账户配置
 */

//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 业务与银行账户配置列表
const bizBankCfgList = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/bizBankCfg/list.vue')));

const bizBankCfg = {
  path: '/bizBankCfg',
  component: index,
  children: [
    {
      path: 'list',
      name: 'bizBankCfgList',
      component: bizBankCfgList,
      meta: {
        keepAlive: true,
        title: '业务与银行账户配置',
      },
    },
  ],
};
export default bizBankCfg;
